import React from 'react';

export default function DataTableGrid({
  columns = [],
  rows = [],
  renderCell,
  rowKey = 'id',
  onRowClick,
  getRowClassName,
  className = '',
  tableClassName = '',
}) {
  return (
    <div className={`cc-table-shell overflow-hidden rounded-xl ${className}`}>
      <div className="overflow-x-auto">
        <table className={`min-w-full text-sm ${tableClassName}`}>
          <thead className="cc-table-head text-[10px] uppercase tracking-[0.14em]">
            <tr>
              {columns.map((column) => (
                <th key={column.key} className={`px-4 py-3 ${column.align === 'right' ? 'text-right' : 'text-left'}`}>
                  {column.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, rowIndex) => {
              const rowIdentifier = row?.[rowKey] || rowIndex;
              return (
                <tr
                  key={rowIdentifier}
                  className={`cc-text-primary border-t border-slate-800/45 ${onRowClick ? 'cursor-pointer hover:bg-[#121f31]/45' : ''} ${getRowClassName ? getRowClassName(row, rowIndex) : ''}`}
                  onClick={onRowClick ? () => onRowClick(row, rowIndex) : undefined}
                >
                  {columns.map((column) => (
                    <td key={`${column.key}-${rowIdentifier}`} className={`px-4 py-3 ${column.align === 'right' ? 'text-right' : ''}`}>
                      {renderCell ? renderCell(row, column, rowIndex) : row?.[column.key]}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
